export default __webpack_public_path__ + "static/media/aircondition.d4fb902b.svg";